import styled from 'styled-components';

export const TitleDiv = styled.div`
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.grayBorder}`};
  padding: 1.6rem 2.4rem;
  display: flex;
  justify-content: space-between;
`;

export const Title = styled.h2`
  font-size: 2.4rem;
  line-height: 2.4rem;
  font-weight: 700;
`;

export const ButtonDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

export const DownloadButton = styled.button`
  padding: 0.8rem 1.6rem;
  border-radius: 0.4rem;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.blue};
  border: ${({ theme }) => `1px solid ${theme.colors.blue}`};
  background: ${({ theme }) => theme.colors.darkBlue};
  transition: all 0.2s;

  &:hover {
    background: rgba(5, 100, 255, 0.2);
  }
`;
